import { Environment, IAppConfiguration } from "./configuration";

export interface IAppConfigurationOptions {
  applicationCode: string;
  releaseVersion: string;
  environment: Environment;
  hostname: string;
  productPath: string;
  useLocalManifest?: boolean;
  localManifestUrl?: string;
  loadConfigurations?: () => IAppConfiguration[];
  // tslint:disable-next-line:comment-format
  // TODO: Dynamically load and inject the roles and country instead of hardcoding em as types? Is it a good idea or bad idea? 💀
  // storage: (...args: any[]) => any;
  // roles: (...args: any[]) => IRole[];
  // country: (...args: any[]) => string;
}
